import Head from 'next/head';
import { GetServerSideProps } from 'next';
import previewMain from '../../public/preview/preview-main.png';
import Works, { WorksProps } from './works';
import { Footer, Header } from '../../components';
import staticWorks from '../../utils/works';
import menu from '../../utils/menu';

export default function WorksPage({ works }: WorksProps) {
  return (
    <>
      <Head>
        <title>Mavinx&apos;s Successful Projects</title>
        <meta property="og:title" content="Mavinx's Successful Projects" />
        <meta property="og:image" content={`${previewMain.src}`} />
        <meta name="twitter:image" content={`${previewMain.src}`} />
        <meta property="og:image:alt" content="Mavinx's Successful Projects" />
        <meta property="og:type" content="product" />
        <meta
          property="og:description"
          content="View Mavinx's successful projects and different solutions. We thrive in web development, mobile apps, e-commerce platforms, and business software. Explore our unique and customized solutions via case studies, testimonials, and customer success stories. Our superior services and solutions may help you reach your company goals."
        />

        <meta
          name="description"
          content="View Mavinx's successful projects and different solutions. We thrive in web development, mobile apps, e-commerce platforms, and business software. Explore our unique and customized solutions via case studies, testimonials, and customer success stories. Our superior services and solutions may help you reach your company goals."
        />
        <meta
          name="keywords"
          content="Mavinx works, project portfolio, successful projects, web development, mobile applications, e-commerce platforms, enterprise software, case studies, testimonials, client success stories, innovative solutions, tailored solutions, business objectives, exceptional services, project showcase"
        />
      </Head>
      <Header appearance="transparent" appearanceLogo="primary" menu={menu} />
      <Works works={works} />
      <Footer />
    </>
  );
}

export const getServerSideProps: GetServerSideProps<WorksProps> = async () => {
  try {
    const works = staticWorks;
    return {
      props: {
        works,
      },
    };
  } catch {
    return {
      notFound: true,
    };
  }
};
